import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import styles from './Modal.module.scss';
import clsx from 'clsx';

export function Modal({
	// modal basic setup
	show,
	button,
	children,
	title,
	buttonName,
	close,
	contentWidth,
	wrapperWidth,
	wrapperMax,
	// purchaser modal tabs
	tabs,
	activeTab,
	onClickTab,
	onClickAddForm,
	//do you want close button?
	includeClose,
	bodyMaxHeight,
	bodyHeight,
	// lead custom styling
	leadStyling,
	isVideoModal,
}) {
	const numOfPurchasers = 2;

	const getVerificationStatusIcon = (param) => {
		switch (param) {
			case 'verified':
			case 'manually_verified':
				return <CheckCircleIcon className={styles.chkIon_success} />;

			case 'requires_input':
				return <CheckCircleIcon className={styles.chkIon_warning} />;
			case 'document_err':
			case 'selfie_err':
				return <CheckCircleIcon className={styles.chkIon_error} />;
			default:
				return <></>;
		}
	};
	return (
		<>
			{show && <div className={styles.back_drop} onClick={close}></div>}
			{(isVideoModal || show) && (
				<div
					className={styles.modal_wrapper}
					style={
						wrapperMax
							? {
									transition: show
										? 'opacity 0.3s linear'
										: 'visibility 0s 0.3s, opacity 0.3s linear',
									visibility: show ? 'visible' : 'hidden',
									opacity: show ? '1' : '0',
									width: wrapperWidth,
									maxWidth: wrapperMax,
							  }
							: {
									transition: show
										? 'opacity 0.3s linear'
										: 'visibility 0s 0.3s, opacity 0.3s linear',
									visibility: show ? 'visible' : 'hidden',
									opacity: show ? '1' : '0',
									width: wrapperWidth,
							  }
					}
				>
					{tabs ? (
						<div className={styles.tab_modal_header}>
							<div className={styles.tab_wrapper}>
								{tabs?.map((el, index) => (
									<div
										className={styles.tab_modal}
										key={index}
										onClick={() => onClickTab(index)}
										style={
											activeTab === index
												? {
														fontWeight: 700,
														textDecoration:
															'underline',
												  }
												: {
														borderBottom:
															'1px solid #828282a6',
												  }
										}
									>
										<span>{el?.firstName || ''}&nbsp;</span>
										<span>{el?.lastName || ''}</span>
										<span>{el?.corporationName}</span>
										{tabs[0]?.corporationName ===
											undefined &&
											getVerificationStatusIcon(
												el?.identification?.verification
													?.status
											)}
									</div>
								))}
								{tabs[0]?.corporationName === undefined &&
									tabs?.length < numOfPurchasers && (
										<div
											className={styles.tab_add}
											onClick={() => onClickAddForm()}
										>
											<AddIcon />{' '}
											<span>Add Purchaser</span>
										</div>
									)}
							</div>
							{includeClose !== false && (
								<span
									onClick={close}
									className={styles.close_icon}
								>
									<CloseIcon />
								</span>
							)}
						</div>
					) : (
						<div
							className={clsx(
								styles.modal_header,
								leadStyling ? styles.modal_header_lead : null
							)}
						>
							<h4>{title}</h4>
							{includeClose !== false && (
								<span
									onClick={close}
									className='close-modal-btn'
									style={{ padding: '0 12px' }}
								>
									<CloseIcon />
								</span>
							)}
						</div>
					)}

					<div
						className={leadStyling ? null : styles.modal_content}
						style={{ minWidth: contentWidth }}
					>
						<div
							className={styles.modal_body}
							style={{
								maxHeight: bodyMaxHeight,
								height: bodyHeight,
							}}
						>
							<div>{children}</div>
						</div>
						{buttonName && (
							<div className={styles.modal_footer}>
								<button
									onClick={button}
									className={styles.btn_cancel}
								>
									{buttonName}
								</button>
							</div>
						)}
					</div>
				</div>
			)}
		</>
	);
}

export default Modal;
